/**
 * Created by Дмитрий on 01.07.2018.
 */
import {EventBus} from "../../event-bus";

class LoadDataHeader {

    init(agParams) {
        this.agParams = agParams;
        this.removable = agParams.removable;
        this.canRename = agParams.canRename;

        this.eGui = document.createElement('div');

        this.eGui.innerHTML = '' +
            '<div class="row">' +
            (this.canRename ? '<div class="col-xs-2 loadDataHeaderMenuButton"><i class="fa ' + this.agParams.menuIcon + '"></i></div>' : '') +
            (this.removable ? '<div class="col-xs-2 removeColumn"><i class="fa fa-times"></i></div>' : '') +
            '<div class="col-xs-8">' + this.agParams.displayName + '</div>' +
            '</div>';

        this.eMenuButton = this.eGui.querySelector(".row").querySelector(".loadDataHeaderMenuButton");
        this.eRemoveButton = this.eGui.querySelector(".row").querySelector(".removeColumn");
        this.modalForm = $('#columnHeaderName');
        this.butSave = this.modalForm.find('#saveHeaderName');

        if (this.eMenuButton) {
            this.onMenuClickListener = this.onMenuClick.bind(this);
            this.eMenuButton.addEventListener('click', this.onMenuClickListener);
        }

        if (this.eRemoveButton) {
            this.onRemoveClickListener = this.onRemoveClick.bind(this);
            this.eRemoveButton.addEventListener('click', this.onRemoveClickListener);
        }
    }

    getGui() {
        return this.eGui;
    }

    onRemoveClick() {
        EventBus.$emit('remove-column', this.agParams.column);
    }

    onMenuClick() {
        var self = this;
        var options = {};
        var inpName = this.modalForm.find('#headerName');

        this.modalForm.on('show.bs.modal', function () {
            inpName.val(self.agParams.displayName);
        });

        this.butSave.on('click', function () {
            eventBus.$emit('change-column-name', self.agParams.column, inpName.val());
            self.modalForm.modal('hide');
        });


        this.modalForm.modal(options);
    }

    destroy() {
        if (this.onMenuClickListener) {
            this.eMenuButton.removeEventListener('click', this.onMenuClickListener)
        }

        this.modalForm.off('show.bs.modal');
        this.butSave.off('click');
    }
}

export default new LoadDataHeader();